import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Lock, Globe2 } from 'lucide-react';

const SECTIONS = [
  {
    to: '/fonctionnalites',
    icon: ShieldCheck,
    title: 'Fonctionnalités',
    text: "Alerte discrète, navigation sécurisée, widget et déclenchement rapide en cas de danger.",
  },
  {
    to: '/famille',
    icon: Users,
    title: 'Famille',
    text: "Suivi de zones, alertes parentales et tranquillité d'esprit pour vos enfants.",
  },
  {
    to: '/vie-privee',
    icon: Lock,
    title: 'Vie Privée',
    text: "Une approche souveraine et transparente : vos données restent sous votre contrôle.",
  },
  {
    to: '/communaute',
    icon: Globe2,
    title: 'Communauté',
    text: "La vision collective du projet et les canaux pour échanger avec les autres utilisateurs.",
  },
];

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } }
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

const SectionsOverview = () => {
  return (
    <section
      className="section-padding"
      style={{
        background: 'linear-gradient(180deg, #050b14 0%, #081222 100%)',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div className="text-center" style={{ marginBottom: '50px' }}>
          <span className="badge-gold">🧭 Aller plus loin</span>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
            color: 'var(--mga-white)',
            marginTop: '10px'
          }}>
            Explorez <span style={{ color: 'var(--mga-gold)' }}>MonAlerte</span> en détail
          </h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '24px'
          }}
        >
          {SECTIONS.map((section) => {
            const IconComp = section.icon;
            return (
              <motion.div key={section.to} variants={cardVariants}>
                <Link
                  to={section.to}
                  className="glass-card"
                  style={{
                    padding: '28px 24px',
                    textAlign: 'left',
                    textDecoration: 'none',
                    display: 'block',
                    height: '100%',
                    boxSizing: 'border-box',
                    border: '1px solid rgba(255,255,255,0.08)',
                    background: 'rgba(11, 31, 58, 0.35)'
                  }}
                >
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: 'rgba(242, 184, 7, 0.12)',
                    border: '1px solid rgba(242, 184, 7, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                    color: 'var(--mga-gold)'
                  }}>
                    <IconComp size={22} />
                  </div>
                  <h3 style={{ color: 'var(--mga-white)', fontSize: '1.15rem', marginBottom: '8px', fontFamily: 'var(--font-display)' }}>
                    {section.title}
                  </h3>
                  <p style={{ color: 'var(--mga-slate-300)', fontSize: '0.9rem', lineHeight: '1.55', margin: 0 }}>
                    {section.text}
                  </p>
                  <span style={{ color: 'var(--mga-gold-light)', fontSize: '0.85rem', fontWeight: 700, display: 'inline-block', marginTop: '16px' }}>
                    Découvrir →
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default SectionsOverview;
